export const BACKEND_URL =
  "https://md5rhmga23.execute-api.us-west-2.amazonaws.com/production";
// export const BACKEND_URL = "http://localhost:4000";
